(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loomies-cart-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loomies-advent-clock')) {
  customElements.define('loomies-advent-clock', class extends HTMLElement {
    connectedCallback() {
      const date = this.dataset.deadline;
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(date || '')) return;
      const target = Date.parse(date), output = this.querySelector('[data-lcd-clock]');
      const units = this.querySelector('[data-lcd-units]').textContent.split('|');
      const tick = () => {
        const remaining = Math.floor((target - Date.now()) / 1000);
        this.hidden = !Number.isFinite(remaining) || remaining <= 0;
        if (this.hidden) { clearInterval(this.timer); return; }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        output.textContent = values.map((v, i) => `${String(v).padStart(2, '0')}${units[i]}`).join(' ');
      };
      tick();
      if (!this.hidden) this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
if (!customElements.get('loomies-cart-upsell')) {
  customElements.define('loomies-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-lcd-add]').addEventListener('click', event => this.add(event));
    }
    async add(event) {
      if (this.busy) return;
      this.busy = true;
      const button = event.currentTarget, drawer = this.closest('cart-drawer'), error = this.querySelector('[data-lcd-error]');
      button.disabled = true;
      error.hidden = true;
      try {
        const body = new FormData();
        body.set('id', button.dataset.variant);
        body.set('quantity', button.dataset.quantity);
        body.set('sections', drawer.getSectionsToRender().map(s => s.id).join(','));
        body.set('sections_url', window.location.pathname);
        drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
        const response = await fetch(window.routes.cart_add_url, {method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body});
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || this.dataset.error);
        drawer.classList.remove('is-empty');
        await drawer.renderContents(state);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'loomies-upsell', productVariantId:button.dataset.variant, cartData:state});
        const status = drawer.querySelector('#CartDrawer-LiveRegionText');
        if (status) status.textContent = this.dataset.success;
      } catch (e) {
        error.textContent = e.message || this.dataset.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        button.disabled = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loomies-review-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('a.lm-review-summary');
  if (!link) return;
  const url = new URL(link.href, window.location.href);
  const target = document.getElementById('bewertungen');
  if (!target || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
  event.preventDefault();
  const drawer = link.closest('cart-drawer');
  if (drawer && typeof drawer.close === 'function') drawer.close();
  requestAnimationFrame(function() {
    target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    target.focus({preventScroll: true});
  });
});
  } catch(e) { console.error(e); }
})();

})();
